module.exports = __webpack_public_path__ + "static/media/options.f656939c.svg";